import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Modal, ModalBody, ModalHeader} from 'reactstrap';

const extractSize = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html || '';
  const iframe = div.querySelector('iframe');
  if (!iframe) return {w: 560, h: 315}; // fallback padrão do YouTube

  const w = parseInt(iframe.getAttribute('width') || '560', 10);
  const h = parseInt(iframe.getAttribute('height') || '315', 10);
  return {w, h};
};

function getYouTubeEmbedUrl(url) {
  const shortRegex = /youtu\.be\/([a-zA-Z0-9_-]+)/;
  const matchShort = url.match(shortRegex);
  if (matchShort) return `https://www.youtube.com/embed/${matchShort[1]}`;

  const longRegex = /v=([a-zA-Z0-9_-]+)/;
  const matchLong = url.match(longRegex);
  if (matchLong) return `https://www.youtube.com/embed/${matchLong[1]}`;

  return '';
}

const montaIframe = (link) => {
  return `<iframe width="560" height="315" src="${getYouTubeEmbedUrl(link)}" title="Ajuda L-Agro" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
};

const sanitize = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html || '';
  const iframes = div.getElementsByTagName('iframe');
  if (iframes.length !== 1) return '';
  const el = iframes[0];

  const allowedAttrs = [
    'width', 'height', 'src', 'title', 'frameborder', 'allow',
    'referrerpolicy', 'allowfullscreen'
  ];
  [...el.attributes].forEach((attr) => {
    if (!allowedAttrs.includes(attr.name.toLowerCase())) {
      el.removeAttribute(attr.name);
    }
  });

  const src = el.getAttribute('src') || '';
  if (!/^https?:\/\/.*/i.test(src)) return '';

  // Remove estilos inline que possam distorcer
  el.removeAttribute('style');

  return el.outerHTML;
};

const VideoModal = () => {
  const dispatch = useDispatch();
  const {isOpen, titulo, urlVideoAjuda} = useSelector((s) => s.videoModalModel);
  const [size, setSize] = useState({w: 560, h: 315});
  const containerRef = useRef(null);

  // useMemo para verificar se é iframe ou link normal e processar adequadamente
  const processedHtml = useMemo(() => {
    if (!urlVideoAjuda) return '';

    // Verifica se o link contém tag iframe
    const isIframeHtml = urlVideoAjuda.includes('<iframe') && urlVideoAjuda.includes('</iframe>');

    if (isIframeHtml) {
      // Se já é um iframe HTML, apenas sanitiza
      return sanitize(urlVideoAjuda);
    } else {
      // Se é um link normal, monta o iframe primeiro e depois sanitiza
      const iframeHtml = montaIframe(urlVideoAjuda);
      return sanitize(iframeHtml);
    }
  }, [urlVideoAjuda]);

  useEffect(() => {
    // Atualiza tamanho sempre que o HTML processado muda
    const {w, h} = extractSize(processedHtml);
    setSize({w, h});
  }, [processedHtml]);

  useEffect(() => {
    if (!isOpen && containerRef.current) {
      containerRef.current.innerHTML = '';
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => dispatch.videoModalModel.close()}
      centered
      // Evita largura "lg" fixa do reactstrap
      // size="lg"
      style={{
        // Ajusta o dialogo ao conteúdo + margens do modal
        maxWidth: size.w + 10 + 2, // 16px padding lateral de cada lado no body aprox.
      }}
    >
      <ModalHeader toggle={() => dispatch.videoModalModel.close()}>
        {titulo}
      </ModalHeader>
      <ModalBody
        style={{
          padding: '5px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#fff', // garante a borda branca
        }}
      >
        <div
          ref={containerRef}
          // Container com o tamanho exato do iframe
          style={{
            width: size.w,
            height: size.h,
            overflow: 'hidden',
            backgroundColor: 'transparent', // remova o azul
          }}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{__html: processedHtml}}
        />
      </ModalBody>
    </Modal>
  );
};

export default VideoModal;
